import { Link, useLocation } from "react-router-dom";

export default function ReservationResult() {
  const reservation = useLocation().state?.reservation;
  if (!reservation) return <main className="p-8 text-center">اطلاعات رزرو در دسترس نیست.</main>;
  return <main className="min-h-screen bg-gray-50 p-8" dir="rtl"><section className="mx-auto max-w-lg rounded-2xl bg-white p-6 text-center shadow-sm">
    <h1 className="text-2xl font-bold text-primary">{reservation.status === "CONFIRMED" ? "رزرو تأیید شد" : "درخواست رزرو ثبت شد"}</h1>
    {reservation.status === "PENDING" && <p className="mt-2 text-sm text-gray-500">در انتظار تأیید رستوران</p>}
    <p className="mt-4">کد پیگیری: {reservation._id}</p><p>تاریخ {reservation.reservationDate}، ساعت {reservation.startTime}</p><p>{reservation.partySize} نفر</p>
    <div className="mt-6 flex justify-center gap-3"><Link className="rounded-xl bg-primary px-5 py-3 text-white" to="/p/my-reservations">رزروهای من</Link><Link className="rounded-xl border px-5 py-3" to="/restaurants">رستوران‌ها</Link></div>
  </section></main>;
}
